import React from "react";
import { AlertOctagon } from "lucide-react";

interface State {
  error: Error | null;
}

/**
 * Filet de sécurité React : intercepte toute erreur jetée dans l'arbre et
 * affiche un message lisible plutôt qu'une page blanche.
 */
export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="min-h-screen bg-background">
        <header className="aurora-hero-gradient px-6 py-10 text-white">
          <div className="mx-auto flex max-w-2xl items-center gap-4">
            <div className="flex items-center justify-center rounded-lg bg-white px-3 py-1.5">
              <img src="/logo-aurora.png" alt="Aurora Digital Solutions" className="h-8 w-auto" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-wide text-white/70">
                Aurora Prospection
              </div>
              <h1 className="text-2xl font-bold">Erreur applicative</h1>
            </div>
          </div>
        </header>

        <div className="mx-auto max-w-2xl px-6 py-10">
          <div className="mb-6 flex items-start gap-3 rounded-lg border border-destructive/40 bg-red-50 p-4">
            <AlertOctagon className="mt-0.5 size-5 shrink-0 text-destructive" />
            <div className="text-sm text-neutral-700">
              <div className="mb-1 font-semibold text-aurora-navy">
                Quelque chose a planté pendant le chargement
              </div>
              <p className="text-neutral-600">
                Détails ci-dessous. Ouvre la console DevTools (F12) pour la stack trace complète.
              </p>
            </div>
          </div>

          <pre className="overflow-auto rounded-lg border border-destructive/30 bg-red-50/50 p-4 font-mono text-xs text-destructive">
            {this.state.error.message}
            {this.state.error.stack && (
              <>
                {"\n\n"}
                {this.state.error.stack}
              </>
            )}
          </pre>

          <button onClick={() => location.reload()} className="btn-aurora-primary mt-6">
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}
